import React, { useEffect, useState } from "react";
import { getAllItemsSearch } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import OpeningSideBar from "../openingSideBar/openingSIdeBar";
// import "./party.css";
import { getAllParty } from "../../api/endpoints/party";
import {
  createSpecialRate,
  getRate,
  deleteSingleVehical,
  updateSpecialRate,
} from "../../api/endpoints/specialRate.js";
const { Option } = Select;

const SpecialRate = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    items: [],
    parties: [],
    itemCode: "",
    itemName: "",
    partyId: "",
    partyName: "",
    saleRate: "",
  });

  const clearState = () => {
    setState({
      id: "",
      parties: state.parties,
      items: state.items,
      itemCode: "",
      itemName: "",
      partyId: "",
      partyName: "",
      saleRate: "",
    });
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.partyId ||
      !state.partyName ||
      !state.saleRate ||
      !state.itemCode
    ) {
      return message.error(
        `Please type ${
          !state.saleRate
            ? "Special Rate"
            : !state.partyId
            ? "Account Number"
            : !state.partyName
            ? "Party Name"
            : !state.itemCode
            ? "Item"
            : ""
        }`
      );
    }

    const payload = {
      partyId: state.partyId,
      saleRate: state.saleRate,
      itemCode: state.itemCode,
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await createSpecialRate(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

 
  const getSpecialRate = async (e) => {
    if (!state.partyId || !state.partyName || !state.itemCode) {
      return message.error(
        `Please type ${
          !state.partyId
            ? "Account Number"
            : !state.partyName
            ? "Party Name"
            : !state.itemCode
            ? "Item"
            : ""
        }`
      );
    }
    const data = {
      partyId: state.partyId,
      itemCode: state.itemCode,
    };
    console.log(data, "edite data");
    const results = await getRate(data, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      if (
        typeof results.data.id !== "undefined" &&
        typeof results.data.saleRate !== "undefined"
      ) {
        const idValue = results.data.id;
        const saleRateValue = Number(results.data.saleRate);

        setState({
          ...state,
          id: idValue,
          saleRate: saleRateValue || "",
        });
      }
    } else {
      message.error(results.message);
    }
  };

  const editSpecialRate = async (e) => {
    if (!state.partyId || !state.partyName || !state.itemCode) {
      return message.error(
        `Please type ${
          !state.partyId
            ? "Account Number"
            : !state.partyName
            ? "Party Name"
            : !state.itemCode
            ? "Item"
            : ""
        }`
      );
    }
    const data = {
      id: state.id,
      partyId: state.partyId,
      saleRate: state.saleRate,
      itemCode: state.itemCode,
    };
    console.log(data, "edite data");
    const results = await updateSpecialRate(data, access_token);
    if (results.success) {
      message.success(results.message || "Successfully Updated!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const confirmDeleteNozel = async () => {
    const data = {
      id: state.id,
    };
    const results = await deleteSingleVehical(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Vehicle?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _parties = await getAllParty(access_token);
    const _items = await getAllItemsSearch(access_token);
    setState({
      ...state,
      parties: _parties,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(state, "state");
  return (
    <>
      <div className="flex bg-black main">
        <OpeningSideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Special Rate</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    <div className="flex justify-evenly w-full">
                      {/* <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Numaric Number :
                        </label>
                        <input
                          type="Number"
                          name="numaricNumber"
                          value={state.numaricNumber}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div> */}
                    </div>

                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Item Code :
                        </label>

                        <Select
                          showSearch
                          placeholder="Item"
                          className="text-black inpTxt  h-9 w-full"
                          optionFilterProp="children"
                          value={state.itemCode || "Item"}
                          onChange={(e) => {
                            console.log("e", e);

                            const _item = state.items.find(
                              (el) => el.itemCode === e
                            );
                            if (_item) {
                              setState({
                                ...state,
                                itemCode: e,
                                itemName: _item.itemName,
                              });
                            }
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemCode}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Item Name :
                        </label>

                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Item Name"
                          optionFilterProp="children"
                          value={state.itemName || "Item Name"}
                          onChange={(e) => {
                            const { itemName } = state.items.find(
                              (el) => el.itemCode === e
                            );
                            setState({
                              ...state,
                              itemCode: e,
                              itemName: itemName,
                            });
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Party Id :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="Party Id"
                          optionFilterProp="children"
                          value={state.partyId || "Party Id "}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyId}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Party Name :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Party Name"
                          optionFilterProp="children"
                          value={state.partyName || "Party Name"}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Special Rate :
                        </label>
                        <input
                          type="text"
                          name="saleRate"
                          value={state.saleRate}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 pl-2  inpTxt h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 flex justify-evenly items-center">
                        {type === "EDIT" && (
                          <button
                            onClick={getSpecialRate}
                            className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 h-8 py-1 px-4 rounded"
                          >
                            {/* <AiFillSave className="mt-1 mr-2 " /> */}
                            <span>Find Rate</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={saveTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded">
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={editSpecialRate}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {/* {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )} */}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialRate;
